/**
 * KpiCard — a summary stat card for report pages
 */
import React from 'react';
import { Loader2, TrendingUp, TrendingDown, Minus } from 'lucide-react';

const KpiCard = ({
  label,
  value,
  sub,
  icon: Icon,
  iconColor = 'text-orange-500',
  iconBg   = 'bg-orange-50',
  loading  = false,
  trend,           // 'up' | 'down' | 'neutral' | undefined
  delta,           // e.g. '+12.3%' | '-4.1%' — rendered in trend color
  testId,
}) => (
  <div
    className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm
      hover:border-orange-200 hover:shadow-md transition-all duration-200"
    data-testid={testId || 'kpi-card'}
  >
    <div className="flex items-start justify-between mb-3">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider leading-snug max-w-[130px]">
        {label}
      </p>
      {Icon && (
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${iconBg}`}>
          <Icon className={`w-4 h-4 ${iconColor}`} />
        </div>
      )}
    </div>

    {loading ? (
      <Loader2 className="w-5 h-5 animate-spin text-gray-300 mt-1" />
    ) : (
      <p className="text-2xl font-bold text-gray-900 leading-none" data-testid={`${testId}-value`}>
        {value}
      </p>
    )}

    {(sub || delta) && !loading && (
      <div className="flex items-center gap-1.5 mt-2 flex-wrap">
        {trend === 'up'      && <TrendingUp   className="w-3 h-3 text-green-500 shrink-0" />}
        {trend === 'down'    && <TrendingDown  className="w-3 h-3 text-red-500   shrink-0" />}
        {trend === 'neutral' && <Minus         className="w-3 h-3 text-gray-400  shrink-0" />}
        {delta && (
          <span className={`text-xs font-semibold ${
            trend === 'up'      ? 'text-green-600' :
            trend === 'down'    ? 'text-red-500'   :
                                  'text-gray-500'
          }`} data-testid={`${testId}-delta`}>
            {delta}
          </span>
        )}
        {sub && (
          <span className="text-xs text-gray-400">{sub}</span>
        )}
      </div>
    )}
  </div>
);

export default KpiCard;
